/**
 * Sentry breadcrumbs for auth, navigation, and API flows.
 * Keep payloads small; no PII or large objects.
 */

import * as Sentry from "@sentry/nextjs";

export function breadcrumbAuth(message: string, data?: Record<string, unknown>): void {
  Sentry.addBreadcrumb({
    category: "auth",
    message,
    data: data ? { ...data } : undefined,
    level: "info",
  });
}

export function breadcrumbNavigation(route: string, data?: Record<string, unknown>): void {
  Sentry.addBreadcrumb({
    category: "navigation",
    message: route,
    data: data ? { ...data } : undefined,
    level: "info",
  });
}

export function breadcrumbGraphQL(operationName: string, data?: Record<string, unknown>): void {
  Sentry.addBreadcrumb({
    category: "graphql",
    message: operationName,
    data: data ? { ...data } : undefined,
    level: "info",
  });
}

export function breadcrumbExternal(service: string, action: string): void {
  Sentry.addBreadcrumb({
    category: "external",
    message: `${service}: ${action}`,
    level: "info",
  });
}
